import 'ol/ol.css';
import GeoJSON from 'ol/format/GeoJSON';
import Map from 'ol/Map';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import View from 'ol/View';
import {Fill, Stroke, Style, Text} from 'ol/style';
import {defaults as defaultInteractions} from 'ol/interaction.js';
import {Control, FullScreen, defaults as defaultControls} from 'ol/control';
import {DEVICE_PIXEL_RATIO} from 'ol/has'
import countries from './data/country-defaults.json';
import {getCenter} from 'ol/extent.js';
const audio = new Audio('./data/click.ogg');
const canvas = document.createElement('canvas');
const context = canvas.getContext('2d');

/*
Copyright 2022 Acez Software LLC
You may not study, use, modify, or distribute this code for any purpose
http://www.allfunapps.com
*/

// Gradient and pattern are in canvas pixel space, so we adjust for the
// renderer's pixel ratio
const pixelRatio = DEVICE_PIXEL_RATIO;

let animateNum = 0;
let questionCountryId = "";
let cnt = 0;
let countryGroup = "";

// set countries
const allArr = ['AFG','AGO','ALB','ARE','ARG','ARM','ATA','ATF','AUS','AUT','AZE','BDI','BEL','BEN','BFA','BGD','BGR','BHS','BIH','BLR','BLZ','BMU','BOL','BRA','BRN','BTN','BWA','CAF','CAN','CHE','CHL','CHN','CIV','CMR','COD','COG','COL','CRI','CUB','TRNC','CYP','CZE','DEU','DJI','DNK','DOM','DZA','ECU','EGY','ERI','ESP','EST','ETH','FIN','FJI','FLK','FRA','GAB','GBR','GEO','GHA','GIN','GMB','GNB','GNQ','GRC','GRL','GTM','GUF','GUY','HND','HRV','HTI','HUN','IDN','IND','IRL','IRN','IRQ','ISL','ISR','ITA','JAM','JOR','JPN','KAZ','KEN','KGZ','KHM','KOR','CS-KM','KWT','LAO','LBN','LBR','LBY','LKA','LSO','LTU','LUX','LVA','MAR','MDA','MDG','MEX','MKD','MLI','MMR','MNE','MNG','MOZ','MRT','MWI','MYS','NAM','NCL','NER','NGA','NIC','NLD','NOR','NPL','NZL','OMN','PAK','PAN','PER','PHL','PNG','POL','PRI','PRK','PRT','PRY','QAT','ROU','RUS','RWA','ESH','SAU','SDN','SDS','SEN','SLB','SLE','SLV','SOL','SOM','SRB','SUR','SVK','SVN','SWE','SWZ','SYR','TCD','TGO','THA','TJK','TKM','TLS','TTO','TUN','TUR','TWN','TZA','UGA','UKR','URY','USA','UZB','VEN','VNM','VUT','PSE','YEM','ZAF','ZMB','ZWE'];
const europeanUnionArr = ['AUT','BEL','BGR','HRV','CYP','TRNC','CZE','DNK','FIN','FRA','DEU','GRC','HUN','IRL','ITA','LVA','LTU','LUX','NLD','POL','PRT','ROU','SVK','SVN','ESP','SWE'];
const americasArr = ['USA','BRA','MEX','COL','ARG','CAN','PER','VEN','CHL','ECU','GTM','BOL','HTI','CUB','HND','PRY','SLV','NIC','CRI','PAN','URY','PRI','JAM','TTO','GUY','SUR','BLZ','BHS','GUF','DOM','BMU','GRL','FLK'];
const latinAmericaArr = ['MEX','GTM','NIC','PAN','COL','VEN','PER','ARG','CHL','BRA','CUB','DOM','HTI','GUY','SUR','GUF','HND','CRI','SLV','BLZ','JAM','PRI','FLK','BOL','ECU','PRY','URY','TTO'];
const africaArr = ['DZA','AGO','BEN','BWA','BFA','BDI','CMR','CAF','TCD','COG','CIV','DJI','EGY','GNQ','ERI','ETH','GAB','GMB','GHA','GIN','KEN','LSO','LBR','LBY','MDG','MWI','MLI','MRT','MAR','MOZ','NAM','NER','NGA','SEN','SLE','SOM','ZAF','SDN','SDS','SWZ','TZA','TGO','TUN','UGA','ZMB','ZWE','COD','RWA','SOL','ESH','GNB'];
const asiaArr = ['AFG','ARM','AZE','BGD','BTN','BRN','KHM','CHN','TRNC','CYP','GEO','IND','IDN','IRN','IRQ','ISR','JPN','JOR','KAZ','KWT','KGZ','LAO','LBN','MYS','MNG','MMR','NPL','PRK','OMN','PAK','PHL','QAT','RUS','SAU','KOR','LKA','SYR','TWN','TJK','THA','TLS','TUR','TKM','ARE','UZB','VNM','YEM'];
const europeArr = ['ARM','AZE','GEO','TUR','EST','MDA','RUS','BLR','UKR','MKD','MNE','ALB','BIH','CS-KM','SRB','CHE','GBR','NOR','AUT','BEL','BGR','HRV','CYP','TRNC','CZE','DNK','FIN','FRA','DEU','GRC','HUN','IRL','ITA','LVA','LTU','LUX','NLD','POL','PRT','ROU','SVK','SVN','ESP','SWE'];
const southAmericaArr = ['ARG','BOL','BRA','CHL','COL','ECU','FLK','GUF','GUY','PRY','PER','SUR','URY','VEN'];

const interactions = defaultInteractions({
  constrainResolution: true,
  onFocusOnly: true,
  doubleClickZoom: false,
  altShiftDragRotate: false,
  pinchRotate: false
});

class HeaderControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement('img');
    element.setAttribute("id", "header");
    element.setAttribute("src", './data/navigation/header.png');
    element.className = 'header ol-unselectable ol-control';
    super({
      element: element,
      target: options.target,
    });
  }
}
class FlagControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement('img');
    element.setAttribute("id", "flag");
    element.className = 'flag ol-unselectable ol-control';
    super({
      element: element,
      target: options.target,
    });
  }
}

class QuestionControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement('div');
    element.style.backgroundColor = '#a1a1a1';
    element.style.color = '#000000';
    element.setAttribute("id", "question");
    element.className = 'question ol-unselectable ol-control';
    super({
      element: element,
      target: options.target,
    });
  }
}

class HowBtnControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement('img');
    element.setAttribute("id", "howBtn");
    element.setAttribute("src",'./data/navigation/how.png');
    element.className = 'howBtn ol-unselectable ol-control';
    super({
      element: element,
      target: options.target,
    });
    element.addEventListener('click', this.open.bind(this), false);
    element.addEventListener('touchstart', this.open.bind(this), false);
  }
  open() {
    document.getElementById("howScreen").style.visibility = "visible";
  }
}

class HomeBtnControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement('img');
    element.setAttribute("id", "homeBtn");
    element.setAttribute("src",'./data/navigation/home.png');
    element.className = 'homeBtn ol-unselectable ol-control';
    super({
      element: element,
      target: options.target,
    });
    element.addEventListener('click', this.open.bind(this), false);
    element.addEventListener('touchstart', this.open.bind(this), false);
  }
  open() {
    window.location.href='https://www.allfunapps.com/webapps/worldcountries/'
  }
}

class HowScreenControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement('img');
    element.setAttribute("id", "howScreen");
    element.setAttribute("src",'./data/navigation/howScreen.png');
    element.className = 'howScreen ol-unselectable ol-control';
    super({
      element: element,
      target: options.target,
    });
    element.addEventListener('click', this.close.bind(this), false);
    element.addEventListener('touchstart', this.close.bind(this), false);
  }
  close() {
    document.getElementById("howScreen").style.visibility = "hidden";
  }
}

class StopBtnControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement('img');
    element.setAttribute("id", "stopBtn");
    element.setAttribute("src",'./data/navigation/stop.png');
    element.className = 'stopBtn ol-unselectable ol-control';
    super({
      element: element,
      target: options.target,
    });
    element.addEventListener('click', this.stop.bind(this), false);
    element.addEventListener('touchstart', this.stop.bind(this), false);
  }
  stop() {

    questionCountryId = "";
    document.getElementById("header").style.visibility = "visible";
    document.getElementById("flag").style.visibility = "hidden";
    document.getElementById("question").style.visibility = "hidden";
    document.getElementById("howBtn").style.visibility = "visible";
    document.getElementById("homeBtn").style.visibility = "visible";
    document.getElementById("howScreen").style.visibility = "hidden";
    document.getElementById("stopBtn").style.visibility = "hidden";
    document.getElementById("startBtn").style.visibility = "visible";
    document.getElementById("settingsBtn").style.visibility = "visible";
    document.getElementById("settings").style.visibility = "hidden";
    vector.getSource().refresh({force:true});

  }
}

class StartBtnControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement('img');
    element.setAttribute("id", "startBtn");
    element.setAttribute("src",'./data/navigation/start.png');
    element.className = 'startBtn ol-unselectable ol-control';
    super({
      element: element,
      target: options.target,
    });
    element.addEventListener('click', this.start.bind(this), false);
    element.addEventListener('touchstart', this.start.bind(this), false);
  }
  start() {

    resetCountries();

    // get selected country group
    countryGroup = getCookie("countryGroup");
    if(countryGroup === null) {
      countryGroup = 'All';
    }

    // countries category -> countries -> features
    // select country category, set specific countries to true
    if(countryGroup === 'All') {
      allArr.forEach((id) => {
        let country =  countries.find(x => x.id == id);
        country.show = true;
      });
    } else if (countryGroup === 'European Union') {
      europeanUnionArr.forEach((id) => {
        let country =  countries.find(x => x.id == id);
        country.show = true;
      });
    } else if (countryGroup === 'Americas') {
      americasArr.forEach((id) => {
        let country =  countries.find(x => x.id == id);
        country.show = true;
      });
    } else if (countryGroup === 'Latin America') {
      latinAmericaArr.forEach((id) => {
        let country =  countries.find(x => x.id == id);
        country.show = true;
      });
    } else if (countryGroup === 'Africa') {
      africaArr.forEach((id) => {
        let country =  countries.find(x => x.id == id);
        country.show = true;
      });
    } else if (countryGroup === 'Asia') {
      asiaArr.forEach((id) => {
        let country =  countries.find(x => x.id == id);
        country.show = true;
      });
    } else if (countryGroup === 'Europe') {
      europeArr.forEach((id) => {
        let country =  countries.find(x => x.id == id);
        country.show = true;
      });
    } else if (countryGroup === 'South America') {
      southAmericaArr.forEach((id) => {
        let country =  countries.find(x => x.id == id);
        country.show = true;
      });
    }


    // loop through countries array and update features array
    let features = vector.getSource().getFeatures();
    features.forEach((feature) => {
      let id = feature.getId();
      const country =  countries.find(x => x.id == id);

      if(country.show) {
        feature.setStyle(styleNoNames);
      } else {
        feature.setStyle(styleHidden);
      }
    });
    cnt = 0;
    if(countryGroup === 'All') {
      shuffle(allArr);
    } else if (countryGroup === 'European Union') {
      shuffle(europeanUnionArr);
    } else if (countryGroup === 'Americas') {
      shuffle(americasArr);
    } else if (countryGroup === 'Latin America') {
      shuffle(latinAmericaArr);
    } else if (countryGroup === 'Africa') {
      shuffle(africaArr);
    } else if (countryGroup === 'Asia') {
      shuffle(asiaArr);
    } else if (countryGroup === 'Europe') {
      shuffle(europeArr);
    } else if (countryGroup === 'South America') {
      shuffle(southAmericaArr);
    }

    nextCountry();

    document.getElementById("header").style.visibility = "hidden";
    document.getElementById("howBtn").style.visibility = "hidden";
    document.getElementById("homeBtn").style.visibility = "hidden";
    document.getElementById("howScreen").style.visibility = "hidden";
    document.getElementById("stopBtn").style.visibility = "visible";
    document.getElementById("startBtn").style.visibility = "hidden";
    document.getElementById("settingsBtn").style.visibility = "hidden";
    document.getElementById("settings").style.visibility = "hidden";

    document.getElementById("question").style.visibility = "visible";
    document.getElementById("flag").style.visibility = "visible";

  }
}

class SettingsBtnControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement('img');
    element.setAttribute("id", "settingsBtn");
    element.setAttribute("src",'./data/navigation/settings.png');
    element.className = 'settingsBtn ol-unselectable ol-control';
    super({
      element: element,
      target: options.target,
    });
    element.addEventListener('click', this.settings.bind(this), false);
    element.addEventListener('touchstart', this.settings.bind(this), false);
  }
  settings() {
    document.getElementById("settings").style.visibility = "visible";
  }
}

class SettingsControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    let values = ["All", "European Union", "Europe", "Americas", "Latin America", "South America", "Africa", "Asia"];

    const element = document.createElement('div');
    element.setAttribute("id", "settings");
    element.style.backgroundColor = '#004d81';

    let select = document.createElement("select");
    select.name = "countryGroup";
    select.id = "countryGroup"
    for (const val of values)
    {
      let option = document.createElement("option");
      option.value = val;
      option.text = val.charAt(0).toUpperCase() + val.slice(1);
      select.appendChild(option);
    }

    let value = getCookie("countryGroup");
    if(value != null) {
      select.value = value;
    }

    let label = document.createElement("label");
    label.style.fontSize = '18px';
    label.style.marginLeft = '5px';
    label.style.color = 'white';
    label.innerHTML = "Countries: "
    label.htmlFor = "countryGroup";

    let btn = document.createElement("button");
    btn.style.backgroundColor = 'white';
    btn.style.marginLeft = '5px';
    btn.style.fontSize = '14px';
    btn.style.color = 'black';
    btn.style.width = '80px';
    btn.innerHTML = "Close";

    element.appendChild(document.createElement("p"));
    element.appendChild(label).appendChild(select);
    element.appendChild(document.createElement("p"));
    element.appendChild(btn);

    element.className = 'settings ol-unselectable ol-control';

    super({
      element: element,
      target: options.target,
    });
    select.addEventListener('change', this.settings.bind(this), false);
    select.addEventListener('touchstart', this.settings.bind(this), false);
    btn.addEventListener('click', this.close.bind(this), false);
  }
  settings(e) {
    setCookie("countryGroup",e.target.value,180);
  }
  close() {
    document.getElementById("settings").style.visibility = "hidden";
  }
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function setCookie(name,value,days) {
  var allowed = getAllowedCookie();
  if (allowed == null) {
    alert("Cookies need to be enabled in order to save data.");
    return;
  }
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getAllowedCookie() {
  var dc = document.cookie;
  var prefix = "allowed=";
  var begin = dc.indexOf("; " + prefix);
  if (begin == -1) {
    begin = dc.indexOf(prefix);
    if (begin != 0) return null;
  } else {
    begin += 2;
    var end = document.cookie.indexOf(";", begin);
    if (end == -1) {
      end = dc.length;
    }
  }
  return decodeURI(dc.substring(begin + prefix.length, end));
}


function resetCountries() {
  countries.forEach((country) => {
    country.show = false;
    country.touched = false;
    country.incorrectCnt = 0;
    country.correct = false;
  });
}

function nextCountry() {
  let flag = document.getElementById( 'flag' );
  let question = document.getElementById( 'question' );

  let len = 0;
  if(countryGroup === 'All') {
    len = allArr.length
  } else if (countryGroup === 'European Union') {
    len = europeanUnionArr.length
  } else if (countryGroup === 'Americas') {
    len = americasArr.length
  } else if (countryGroup === 'Latin America') {
    len = latinAmericaArr.length
  } else if (countryGroup === 'Africa') {
    len = africaArr.length
  } else if (countryGroup === 'Asia') {
    len = asiaArr.length
  } else if (countryGroup === 'Europe') {
    len = europeArr.length
  } else if (countryGroup === 'South America') {
    len = southAmericaArr.length
  }

  if(cnt >= len) {
    questionCountryId = "";
    flag.setAttribute("src",'./data/country-images/xx.png');
    document.getElementById("flag").style.visibility = "hidden";

    // display % correct
    let correctCnt = 0;
    let totalCnt = 0;
    countries.forEach((country) => {
      if (country.show) {
        if (country.correct) {
          correctCnt++
        }
        totalCnt++;
      }
    });
    let grade = ((correctCnt/totalCnt) * 100).toFixed(0)
    question.innerHTML =  grade + '% Correct';

  } else {
    let f;

    if(countryGroup === 'All') {
      f = vector.getSource().getFeatureById(allArr[cnt]);
      questionCountryId = allArr[cnt];
    } else if (countryGroup === 'European Union') {
      f = vector.getSource().getFeatureById(europeanUnionArr[cnt]);
      questionCountryId = europeanUnionArr[cnt];
    } else if (countryGroup === 'Americas') {
      f = vector.getSource().getFeatureById(americasArr[cnt]);
      questionCountryId = americasArr[cnt];
    } else if (countryGroup === 'Latin America') {
      f = vector.getSource().getFeatureById(latinAmericaArr[cnt]);
      questionCountryId = latinAmericaArr[cnt];
    } else if (countryGroup === 'Africa') {
      f = vector.getSource().getFeatureById(africaArr[cnt]);
      questionCountryId = africaArr[cnt];
    } else if (countryGroup === 'Asia') {
      f = vector.getSource().getFeatureById(asiaArr[cnt]);
      questionCountryId = asiaArr[cnt];
    } else if (countryGroup === 'Europe') {
      f = vector.getSource().getFeatureById(europeArr[cnt]);
      questionCountryId = europeArr[cnt];
    } else if (countryGroup === 'South America') {
      f = vector.getSource().getFeatureById(southAmericaArr[cnt]);
      questionCountryId = southAmericaArr[cnt];
    }

    const country =  countries.find(x => x.id == questionCountryId);
    flag.setAttribute("src",'./data/country-images/' + country.img + '.png');
    question.innerHTML = f.get('name');
    cnt++;
  }
}

const hidden = (function () {
  canvas.width = 8 * pixelRatio;
  canvas.height = 8 * pixelRatio;
  // white background
  context.fillStyle = 'white';
  context.fillRect(0, 0, canvas.width, canvas.height);
  // inner circle
  context.fillStyle = 'rgb(211, 211, 211)';
  context.beginPath();
  context.arc(2 * pixelRatio, 2 * pixelRatio, 1.2 * pixelRatio, 0, 2 * Math.PI);
  context.fill();
  return context.createPattern(canvas, 'repeat');
})();

const styleName = new Style({
  fill: new Fill({
    color: '#636363' //'rgba(2, 255, 255, 0.6)',
  }),
  stroke: new Stroke({
    color: '#000000',
    width: 1,
  }),
  text: new Text({
    fill: new Fill({
      color: '#FFFFFF',
    }),
    //font: 'bold 48px serif'
  }),
});

const styleNoNames = new Style({
  fill: new Fill({
    color: '#636363' //'rgba(2, 255, 255, 0.6)',
  }),
  stroke: new Stroke({
    color: '#000000',
    width: 1,
  }),
});

const styleBlink = new Style({
  fill: new Fill({
    color: '#FF0000' //'rgba(2, 255, 255, 0.6)',
  }),
  stroke: new Stroke({
    color: '#000000',
    width: 1,
  }),
});

const styleHidden = new Style({
  fill: new Fill({
    color: hidden
  }),
  stroke: new Stroke({
    color: '#000000',
    width: 1,
  }),
});

const vector = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/countries.geojson',
    format: new GeoJSON(),
  }),
  style: function (feature) {
    styleName.getText().setText(feature.get('name'));
    return styleName;
  },
});

const map = new Map({
  controls: defaultControls().extend([
      new HeaderControl(),
      new FlagControl(),
      new QuestionControl(),
      new HowBtnControl(),
      new HomeBtnControl(),
      new HowScreenControl(),
      new StopBtnControl(),
      new StartBtnControl(),
      new SettingsBtnControl(),
      new SettingsControl(),
      new FullScreen()
  ]),
  layers: [vector],
  target: 'map',
  view: new View({
    center: [0, 0],
    zoom: 2,
  }),
  interactions: interactions,
});

map.on('click', function (e) {

  map.forEachFeatureAtPixel(e.pixel, function (f) {

      if(questionCountryId === "") {
        return;
      }

      // get country id
      let id = f.getId();

      // get country from country-defaults.json
      const country = countries.find(x => x.id == id);
      const questionCountry = countries.find(x => x.id == questionCountryId);

      if(country.show === true) {

        if(country.id === questionCountryId) {

          audio.play();
          f.setStyle(
            new Style({
              fill: new Fill({
                color: randomColor(),
              }),
              stroke: new Stroke({
                color: '#000000',
                width: 1,
              }),
              text: new Text({
                fill: new Fill({
                  color: '#FFFFFF',
                }),
              }),
            })
          )

          if(questionCountry.incorrectCnt === 0) {
            questionCountry.correct = true;
          }
          // reset name since it's blown away by creating a style over the country
          f.getStyle().getText().setText(f.get('name'));
          nextCountry();

        } else {

          let feature;
          let features = vector.getSource().getFeatures();
          features.forEach((feature1) => {
            if(feature1.getId() === questionCountryId) {
              feature = feature1;
              return;
            }
          });

          var ext = feature.getGeometry().getExtent();
          var pt = getCenter(ext);
          questionCountry.incorrectCnt = questionCountry.incorrectCnt + 1;
          animateNum = 1;

          if(questionCountry.incorrectCnt > 1) {
            map.getView().animate({zoom: 4}, {center: map.getView().setCenter(pt)}, animateCallback);
          } else {
            animateProcess();
          }
        }
      }

    return true;
  });
});

function animateCallback (complete) {
  if (complete) {
    animateProcess();
  }
}

function animateProcess() {
  let feature = vector.getSource().getFeatureById(questionCountryId);
  if (animateNum <= 9)
  {
    if(animateNum%2 == 0) {
      feature.setStyle(styleBlink);
    } else {
      feature.setStyle(styleNoNames);
    }
    setTimeout(animateProcess,75);
  }
  animateNum++;
}

function randomColor() {
  let r = Math.round(Math.random() * 255);
  let g = Math.round(Math.random() * 255);
  let b = Math.round(Math.random() * 255);
  return 'rgba('+r+','+g+','+b+',0.6)';
}

function shuffle(array) {
  let currentIndex = array.length,  randomIndex;
  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
  return array;
}



/* extra code for Start method */

// get specific feature
//let feature = vector.getSource().getFeatureById('ARM');

// remove country names
/*
let features = vector.getSource().getFeatures();
for (let i = 0; i < features.length; i++) {
  features[i].setStyle(styleNoNames);
}
*/

// refresh everything
//vector.getSource().refresh({force:true});

// testing new way to refresh - has error with country name
/*
let features = vector.getSource().getFeatures();
for (let i = 0; i < features.length; i++) {
  console.log(features[i].get('name'))
  features[i].setStyle(style);
}
*/

// examples
/*
let features = vector.getSource().getFeatures();
features.forEach((feature) => {
  console.log(feature.get('name'));
  console.log(feature.getId());
  if(feature.get('name') === 'United States of America') {
    vector.getSource().removeFeature(feature);
  }
});
*/

// hidden
/*
let features = vector.getSource().getFeatures();
for (let i = 0; i < features.length; i++) {
  features[i].setStyle(styleHidden);
}
*/

// load defaults and change based on settings
/*
let features = vector.getSource().getFeatures();
features.forEach((feature) => {
  let id = feature.getId();
  const country =  countries.find(x => x.id == id);
  console.log(country.incorrectCnt);
  if(country.show === false) {
    feature.setStyle(styleHidden);
  }
});
*/